import PropTypes from 'prop-types';

import {copyableProperty, getContentTierName, getProperty} from '../common';

export const thirdLevelCategory = (event) => {
    const eventData = {
        data: event,
        nonSr: ['content_category'],
    };

    return copyableProperty(
        eventData,
        'Content category',
        getProperty(eventData, 'name') + getContentTierName(event)
    );
};

thirdLevelCategory.propTypes = {
    event: PropTypes.object.isRequired,
};
